<template>
  <div class="container">
    <el-container> 
        <el-header height="100px">
            <img src="static/image/banner1.jpg" alt="banner" class="banner-section" >
        </el-header>
        <el-main>
            <!-- 步骤条 -->
            <el-steps :active="2" process-status="process" align-center class="m-t-20">
                <el-step title="產業嘉賓注册" status="success"></el-step>
                <el-step title="資料稽核" status="success"></el-step>
                <el-step title="交費"></el-step>
                <el-step title="交費確認"></el-step>
            </el-steps>

            <!-- 基本資訊表单 -->
            <el-card class="box-card">
                <div slot="header" class="t-a-left">
                    <span>嘉賓資訊</span>
                </div>
                <div  v-if="guestInfo.id!=''">
                    <div v-if="guestInfo.type == 'media'">
                    <el-form label-width="120px" class="demo-ruleForm" label-position="left" ref="ruleForm2">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="姓名：" class="left-align-label">
                                    {{guestInfo.contact}}
                                </el-form-item>
                            </el-col>   
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="身份證件號碼：" class="left-align-label">
                                    {{guestInfo.card_no}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="性别：" class="left-align-label">
                                    {{gender_text(guestInfo.gender)}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="所在國家/城市：" class="left-align-label">
                                    {{guestInfo.country}}
                                </el-form-item>
                            </el-col> 
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="聯繫地址：" class="left-align-label">
                                    {{guestInfo.contact_address}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="出生日期：" class="left-align-label">
                                    {{guestInfo.birthday}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="所屬媒體：" class="left-align-label">
                                    {{guestInfo.name}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="辦公地址：" class="left-align-label">
                                    {{guestInfo.address}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="聯繫電話：" class="left-align-label">
                                    {{guestInfo.phone}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="職務：" class="left-align-label">
                                    {{guestInfo.position}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="聯繫郵箱：" class="left-align-label">
                                    {{guestInfo.email}}
                                </el-form-item>
                            </el-col>  
                        </el-row>
                    </el-form>
                    </div>
                    <div v-else-if="guestInfo.type == 'industry'">
                    <el-form label-width="120px" class="demo-ruleForm" label-position="left" ref="ruleForm2">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="公司名稱：" class="left-align-label">
                                    {{guestInfo.name}}
                                </el-form-item>
                            </el-col>    
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="聯繫人：" class="left-align-label">
                                    {{guestInfo.contact}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="職務：" class="left-align-label">
                                    {{guestInfo.position}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="聯繫電話：" class="left-align-label">
                                    {{guestInfo.phone}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="聯繫郵箱：" class="left-align-label">
                                    {{guestInfo.email}}
                                </el-form-item>
                            </el-col> 
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="所在國家/城市：" class="left-align-label">
                                    {{guestInfo.country}}
                                </el-form-item>
                            </el-col>  
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="公司地址：" class="left-align-label">
                                    {{guestInfo.address}}
                                </el-form-item>
                            </el-col>   
                            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="業務：" class="left-align-label">
                                    {{guestInfo.business}}
                                </el-form-item>
                            </el-col>  
                        </el-row>
                    </el-form>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card">
                <!-- <div slot="header" class="t-a-left">
                    <span>掃碼支付</span>
                </div> -->
                <div  v-if="guestInfo.id==''">
                    <span class="red">{{msg}}</span>
                </div>
                <div v-else-if="guestInfo.type=='industry'">
                    <div v-if="guestInfo.status=='verified'">
                        <!-- <div class="block">
                            <div class="tip">點擊放大</div>
                            <el-image src="static/image/pay.jpg" :preview-src-list="['static/image/pay-big.jpg']" style="max-width: 600px; margin-top: 10px;"></el-image>
                        </div> -->
                        <!-- <div class="m-t-20"><span class="demonstration">請使用微信掃描二維碼完成支付，然後上傳支付信息截圖。</span></div> -->
                        <div class="m-t-20 text-left">
                            <p>溫馨提示：</p>
                            <p><span class="red">*</span> 转款请备注单位名称或个人姓名， </p>
                            <p><span class="red">*</span> 转款完成请上傳支付信息截圖。</p>
                            <p>收款賬戶名稱：广东海上云天影视集团有限公司</p>
                            <p>開戶行：中信银行珠海分行营业部</p>
                            <p>帳號：8110 9010 1210 0977 461</p>
                        </div>
                    </div>
                    <div v-if="guestInfo.status=='paid'">已完成支付</div>
                    <div v-if="guestInfo.status=='new'">暫未審核</div>
                    <div v-if="guestInfo.status=='rejected'">未通過審核</div>
                </div>
                <div v-else-if="guestInfo.type=='media'">
                    <div>您無需支付</div>
                </div>

            </el-card>

            <el-card class="box-card" v-if="guestInfo.type == 'industry' && (guestInfo.status == 'verified' || guestInfo.status == 'paid')">
                <div slot="header" class="t-a-left">
                    <span>上傳支付截圖</span>
                </div>
                    
                <el-form label-width="120px" :rules="rules" ref="ruleForm" :model="FormData" label-position="top">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="支付截圖" label-width="auto" prop="paid_pic" class="left-align-label">
                                                                
                                <el-upload
                                    :action="upload_url"
                                    :before-upload="handleBeforeUpload"
                                    accept="image/*"
                                    :show-file-list="false"
                                    :on-success="handleSuccess"
                                    :on-error="handleError"
                                    :on-change="handleFileChange"
                                    list-type="picture-card"
                                    :data="{'field':'paid_pic','is_tmp':'1'}"
                                >
                                <img v-if="FormData.paid_pic" :src="FormData.paid_pic" class="business-uploader">
                                <i v-else class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" v-if="guestInfo.type == 'industry' && guestInfo.status == 'verified'">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')" disabled>提交</el-button>
                                <el-button @click="resetForm('ruleForm')">重設</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
            
        </el-main>
    </el-container>
    <!-- 左侧导航栏 -->
    <!-- <el-aside width="200px">
      <el-menu :default-active="activeMenu" class="el-menu-vertical-demo">
        <el-menu-item index="1">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-s-platform"></i>
            <span>产业嘉宾</span>
          </template>
          <el-menu-item index="2-1">产业嘉宾注册</el-menu-item>
          <el-menu-item index="2-2">产业嘉宾证件申报</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-s-flag"></i>
            <span>展会</span>
          </template>
        </el-submenu>
        <el-menu-item index="4">
          <i class="el-icon-user"></i>
          <span slot="title">My Page</span>
        </el-menu-item>
      </el-menu>
    </el-aside> -->

  </div>
</template>

<script>
  import setting from '@/setting'
  import {submitGuestPay,getGuestInfo} from '@/api/guest'
export default {
    data() {
        return {
            activeMenu: '2-1',
            upload_url: setting.apiBaseURL + '/upload',
            FormData: {
                id:'',
                paid_pic: '',
            },
            rules: {
                paid_pic: [
                    { required: true, message: '請上傳支付截圖', trigger: 'blur' }
                ],
            },
            guestInfo: {
                id:'',
                type:''
            },
	        msg:'正在査詢...',
            encodeId:'',
        };
    },
    created() {
        console.log(this.$route.params)
        const id = this.$route.params.id
        console.log('当前ID:', id)
        if (id) {
            this.encodeId = id
            // this.FormData.id = id
        }
        this.getInfo()
    },
    methods: {
        getInfo(){
            if (this.encodeId == '') {
                this.$message.error('未獲取到正確參數')
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在獲取資訊...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            getGuestInfo({id:this.encodeId}).then((res)=>{
                if (loading) {
                    loading.close()
                }
                console.log(res)
                if (res.code == 200){
                    this.guestInfo = res.data;
                    if(this.guestInfo.paid_pic!=''){
                        this.FormData.paid_pic = this.guestInfo.paid_pic
                    }
                    this.FormData.id = this.encodeId
                    console.log(this.guestInfo)
                }else{
                    this.$message.error(res.msg || '獲取失敗，請稍後重試。An error occurred, Please try again later.')
                    this.msg = res.msg
                }
            }).catch (error=> {      
                if (loading) {
                    loading.close()
                }
                this.msg = error.msg
                this.$message.error(error.msg || '獲取失敗，請檢查網絡連接。Please check your network connection.')
            }) 
        },
        submitForm(formName) {
            return false;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 显示提交确认对话框
                    this.$confirm('確認提交嗎？ <br>   Do you want to confirm and submit your application? ', '確認提交 Confirm Submission', {
                        confirmButtonText: '確認 Confirm',
                        cancelButtonText: '取消 Cancel',
                        type: 'warning',
                        dangerouslyUseHTMLString: true
                    }).then(() => {
                        // 用户点击确认
                        this.processSubmit()
                    }).catch(() => {
                        // return
                    })
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async processSubmit () {
            // 显示加载状态
            const loading = this.$loading({
                lock: true,
                text: '資料提交中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            try {
                submitGuestPay(this.FormData).then(res => {
                    if (loading) {
                        loading.close()
                    }
                    if (res.status==200) {
                        this.$confirm(res.msg, '資料提交成功。Submission Successful.', {
                            confirmButtonText: '確認 Confirm',
                            cancelButtonText: '',
                            type: 'success',
                            showCancelButton: false,
                            dangerouslyUseHTMLString: true
                        }).then(() => {
                            // 用户点击确认
                            // this.resetForm('ruleForm')
                        }).catch(() => {
                            // return
                        })
                    } else {
                        // 提交失败
                        this.$message.error(res.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
                    }
                }).catch (error=> {      
                    if (loading) {
                        loading.close()
                    }
                    // 提交失败
                    this.$message.error(error.msg || '提交失敗，請檢查網絡連接。Submission Failed. Please check your network connection.')
                }) 
            } catch (error) {
                // 关闭加载状态
                if (loading) {
                    loading.close()
                }
                console.error('提交失敗:', error)
                this.$message.error('提交失敗，請檢查網絡連接後重試。Submission Failed. Please check your network connection and try again later.')
            }
        },
        handleBeforeUpload (file) {
            if (file.size > 10 * 1024 * 1024) {
            this.$message.error('文件大小不能超過10MB')
            return false
            }
        },
        handleSuccess (rep, file, fileList) {
            console.log('handleSuccess')
            console.log(rep, file, fileList)
            if (typeof rep !== 'undefined' && typeof rep.status !== 'undefined' && rep.status === 200) {
            if (typeof rep.data.field !== 'undefined' && rep.data.url) {
                this.$set(this.FormData, rep.data.field, rep.data.url)
            }
            }
        },
        handleError (err, file, fileList) {
            console.log(err, file, fileList)
        },
        handleFileChange (file, fileList) {
            console.log('handleFileChange', file)
            console.log(file, fileList)
        },
        gender_text(val) { 
            if (val == 0 || val == '') {
                return ''
            }
            let tmp = ''
            switch (val) {
                case 'male':
                    tmp = '男'
                    break;
                case 'female':
                    tmp = '女'
                    break;
                default:
                    tmp = ''
                    break;
            }
            return tmp;
        },
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    /* height: 100vh; 占满全屏 */
    display: flex;
    overflow: hidden;
    background: #f5f8ff; /* 全页面背景色 */
    scrollbar-width: none; /* Firefox */
}
.container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge */
}
.el-header{
    padding: 0;
}
.banner-section{
    width: 100%;
}
/* 样式部分 */
.el-aside {
  background-color: #f5f7fa;
}

.el-main {
    padding: 20px;
    margin: 20px;
    background-color: white; /* 表单部分背景色 */
    padding: 20px; /* 添加内边距以确保内容与边缘有间距 */
    border-radius: 30px; /* 圆角效果 */
}
.box-card{
    margin:30px 50px;
}
.el-card__body{
    padding: 20px;
}
.t-a-left{
    text-align: left;
}
.m-t-20{
    margin-top: 20px;
}
.left-align-label{
  text-align: left !important; /* 强制左对齐 */
}
.red{
    color: red;
}
.tip{
    color:#999;
    font-size: 14px;
}
.business-uploader{
    height: 150px;
}
.text-left{
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/guest/industry/pay.vue